import {
  COUNTRY_LOCALIZATION_DETAILS,
  CURRENCY_RATE_TYPE,
  GERMANY_COUNTRY_CODE,
  LANGUAGE_SUPPORTED_CODE,
  SPAIN_COUNTRY_CODE,
} from './constant';

import {pushViewAction} from '../redux/actions/Actions';
import {appStore} from '../redux/createStore';
import {getAPICall, postAPICall} from '../services/apiCallsHandler';

import {German} from 'flatpickr/dist/l10n/de';
import {Spanish} from 'flatpickr/dist/l10n/es';

export const sleep = async (secs) =>
  await new Promise((r) => setTimeout(r, secs * 1000));

export const Navigate = (view) => {
  appStore.dispatch(pushViewAction(view));
};

export const enqueueToastUI = (
  statusCode,
  enqueueToast,
  successTitle,
  errorTitle
) => {
  enqueueToast({
    variant: statusCode == 200 ? 'success' : 'error',
    title: statusCode == 200 ? successTitle : errorTitle,
    isCloseable: true,
  });
};

export const getAllRelationships = (data) => {
  const relationship = [];
  if (data?.organisation && Object.keys(data.organisation).length > 0) {
    Object.keys(data.organisation).forEach((key) => {
      const mapping = {};
      mapping[key] = data.organisation[key].name;
      relationship.push(mapping);
    });
  }
  return relationship;
};

export const getUsername = (data) => {
  if (data.personal.name) {
    return data.personal.name;
  } else {
    return Object.values(data.organisation)[0]
      ? Object.values(data.organisation)[0].name
      : '';
  }
};

export const formatCurrency = (value, type) => {
  const countryCode = getCountryCode();
  const currencyFormatter = new Intl.NumberFormat(
    COUNTRY_LOCALIZATION_DETAILS[countryCode].languageCode || 'en-US',
    {
      ...(type !== CURRENCY_RATE_TYPE && {
        style: COUNTRY_LOCALIZATION_DETAILS[countryCode].style,
      }),
      currency: COUNTRY_LOCALIZATION_DETAILS[countryCode].currency,
      minimumFractionDigits:
        COUNTRY_LOCALIZATION_DETAILS[countryCode].minimumFractionDigits,
      useGrouping: COUNTRY_LOCALIZATION_DETAILS[countryCode].useGrouping,
      ...(type === CURRENCY_RATE_TYPE && {
        maximumFractionDigits:
          COUNTRY_LOCALIZATION_DETAILS[countryCode].maximumFractionDigits,
      }),
    }
  );
  return currencyFormatter.format(value);
};

export const paymentRemainDays = (value) => {
  const date = new Date(value);
  return Math.ceil(
    (date.getTime() - new Date().getTime()) / (1000 * 3600 * 24)
  );
};

export const dateFormatter = (originalDate) => {
  const countryCode = getCountryCode();
  let options = {year: 'numeric', month: 'short', day: '2-digit'};
  const formattedDate = new Date(originalDate).toLocaleDateString(
    COUNTRY_LOCALIZATION_DETAILS[countryCode].languageCode || 'en-US',
    options
  );
  return (
    formattedDate.slice(0, 3) +
    formattedDate.charAt(3).toLocaleUpperCase() +
    formattedDate.slice(4).replace(',', '')
  );
};

export const dateFormatterMY = (originalDate) => {
  const countryCode = getCountryCode();
  let options = {year: 'numeric', month: 'short'};
  const formattedDate = new Date(originalDate).toLocaleDateString(
    COUNTRY_LOCALIZATION_DETAILS[countryCode].languageCode || 'en-US',
    options
  );
  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
};

export const generateTraceID = (oktaUsername) => {
  const session_traceId = sessionStorage.getItem('trace-id');
  if (!session_traceId) {
    const currentDate = Date.now();
    const crypto = globalThis.crypto || globalThis.msCrypto;
    let array = new Uint32Array(1);
    const userID =
      btoa(crypto.getRandomValues(array)[0].toString()).substring(0, 5) +
      btoa(oktaUsername);
    const traceID = `${userID}_${currentDate}`;

    sessionStorage.setItem('trace-id', traceID);
  }
};

export const getBrowserLanguage = () => {
  const languageCode = navigator.language
    ? navigator.language.split('-')[0]
    : 'en';
  return languageCode;
};

export const replaceTranslations = (translatedText, ...args) => {
  let i = 0;
  while (i < args.length) {
    translatedText = translatedText.replace('*#*#', args[i]);
    i++;
  }
  return translatedText;
};

export const getCountryCode = () => {
  return LANGUAGE_SUPPORTED_CODE.includes(localStorage.getItem(`countryCode`))
    ? localStorage.getItem(`countryCode`).toLowerCase()
    : 'en';
};

export const getLocalDatePickerFile = () => {
  let localizationFile;
  const countryCode = getCountryCode();
  if (countryCode === GERMANY_COUNTRY_CODE) {
    localizationFile = German;
  } else if (countryCode === SPAIN_COUNTRY_CODE) {
    localizationFile = Spanish;
  }
  return localizationFile;
};

export const callNumber = (number) => {
  if (globalThis.ReactNativeWebView) {
    globalThis.ReactNativeWebView.postMessage(JSON.stringify({number}));
  }
};

export const getCountryBasedFields = (fieldsConfig, countryFields) => {
  return fieldsConfig.filter((fieldConfig) => {
    return countryFields.includes(fieldConfig.label);
  });
};

export const OpenWebURL = (key, url, type) => {
  if (globalThis.ReactNativeWebView) {
    globalThis.ReactNativeWebView.postMessage(JSON.stringify({[key]: url}));
  } else if (type === 'sameTab') {
    window.open(url, '_self');
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

export const sendCustomDataNR = (
  actionName,
  traceId,
  country,
  errorMessage,
  successful,
  custId,
  uniqueId
) => {
  const newrelic = globalThis.newrelic;

  if (typeof newrelic === 'object') {
    newrelic.addPageAction(actionName, {
      traceId: traceId,
      country: country,
      errorMessage: errorMessage,
      status: successful,
      custId: custId || null,
      uniqueId: uniqueId || null,
    });
  }
};

// Emits a New Relic PageAction for a soft-navigation screen view. This SPA uses
// a Redux view-stack so the browser URL never changes; this event is what NRQL
// funnels use to measure screen-to-screen conversion, independently of Smartlook.
export const sendScreenViewNR = (screen) => {
  const newrelic = globalThis.newrelic;

  if (typeof newrelic === 'object') {
    newrelic.addPageAction('screen_view', {
      screen: screen,
      country: localStorage.getItem('countryCode') || null,
      traceId: sessionStorage.getItem('trace-id') || null,
    });
  }
};

export const serviceRequestPostCall = (
  params,
  enqueueToast,
  errorTag,
  successAction,
  limitMessage,
  successMessage,
  failureMessage,
  reduxAction,
  redirectToOops
) => {
  postAPICall(
    'serviceRequest',
    {
      ...params,
    },
    {
      errorTag: errorTag,
      redirectToOops: redirectToOops,
    }
  ).then((res) => {
    successAction(res.body);

    if (res.status === 429) {
      enqueueToastUI(res.status, enqueueToast, null, limitMessage);
    } else if (!res.body?.isAutomated) {
      //res.status === 200 &&
      enqueueToastUI(res.status, enqueueToast, successMessage, failureMessage);
    }
    if (res.status == 200) {
      const isAutomatedRequest = res.body?.isAutomated;
      reduxAction(isAutomatedRequest);
    }
  });
};

export const sanitizeInput = (string) => {
  // Normalize unicode to collapse fullwidth lookalikes (e.g. ＜ ＞ → < >)
  const normalized = string.normalize('NFKC');
  const sanitizedInput = normalized
    .replace(/[<>]/g, '')
    .replace(/javascript\s*:/gi, '')
    .replace(/vbscript\s*:/gi, '')
    .replace(
      /(http|https|ftp|mailto|tel|file|data):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]*[-A-Za-z0-9+&@#/%=~_|]/g,
      ''
    )
    .replace(/\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+/g, '');

  return sanitizedInput;
};

export const downloadPDF = (docType, enqueueToast, setIsDownloading, t) => {
  setIsDownloading(true);
  const errorTag = {
    LEGAL_DOC: 'GET_DOWNLOAD_LEGAL_DOC',
    TNC_DOC: 'GET_TNC_DOC',
    PRICE_LIST_DOC: 'GET_PRICE_LIST_DOC',
  };
  const downloadName = {
    LEGAL_DOC: 'JohnDeere_DataPrivacy_',
    TNC_DOC: 'JohnDeere_TermsAndConditions_',
    PRICE_LIST_DOC: 'JohnDeere_Prices_Fees_Services_',
  };
  getAPICall(
    `download?docType=${docType}`,
    {
      isCallBack: false,
      errorTag: errorTag[docType],
      redirectToOops: false,
    },
    {}
  ).then((res) => {
    if (res.url) {
      if (globalThis.ReactNativeWebView) {
        globalThis.ReactNativeWebView.postMessage(
          JSON.stringify({
            docUrl: res.url,
            docName: `${downloadName[docType]}${new Date().getTime()}.pdf`,
          })
        );
      } else {
        window.open(res.url, '_blank');
      }
    } else {
      enqueueToastUI(400, enqueueToast, '', t('DOWNLOAD_ERROR_MSG'));
    }
    setIsDownloading(false);
  });
};

export const getContractType = (productLine) => {
  switch ((productLine || '').toUpperCase()) {
    case 'LEASE-OPERATING':
      return 'RNT';
    case 'LEASE-FINANCE':
      return 'LSN';
    case 'LOAN-INSTALLMENT':
      return 'FIN';
    default:
      return '';
  }
};
export const getCancellationType = (productLine) => {
  switch ((productLine || '').toUpperCase()) {
    case 'LEASE-OPERATING':
      return 'DA';
    case 'LEASE-FINANCE':
      return 'TD';
    case 'LOAN-INSTALLMENT':
      return 'RD';
    default:
      return '';
  }
};

export const openDocumentFromBase64 = (base64String, fileType, docName) => {
  const dataUrl = `data:${fileType};base64,${base64String}`;
  if (globalThis.ReactNativeWebView) {
    globalThis.ReactNativeWebView.postMessage(
      JSON.stringify({docUrl: dataUrl, docName})
    );
  } else {
    try {
      const blob = base64ToBlob(base64String, fileType);
      const blobUrl = URL.createObjectURL(blob);
      const newTab = window.open(blobUrl, '_blank', 'noopener,noreferrer');
      if (!newTab) {
        alert('Please allow popups for this website to view the document.');
      }
      setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
    } catch (err) {
      // eslint-disable-next-line
      console.error('Error opening document:', err);
    }
  }
};

const base64ToBlob = (base64, mimeType = '') => {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, {type: mimeType});
};

export const convertUTCToLocalFormat = (utcInput) => {
  const FORMAT_REGEX = /^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}:\d{3}$/;
  if (typeof utcInput !== 'string' || !FORMAT_REGEX.test(utcInput)) {
    return '';
  }
  const isoString = utcInput
    .replace(/\//g, '-')
    .replace(' ', 'T')
    .replace(/:(\d{3})$/, '.$1Z');

  const utcDate = new Date(isoString);

  if (isNaN(utcDate.getTime())) {
    return '';
  }

  const localDate = new Date(
    utcDate.getTime() - utcDate.getTimezoneOffset() * 60000
  );

  const day = localDate.getUTCDate().toString().padStart(2, '0');
  const month = (localDate.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = localDate.getUTCFullYear();

  let hours = localDate.getUTCHours();
  const minutes = localDate.getUTCMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours || 12;
  const formattedHours = hours.toString();
  return `${day}/${month}/${year} | ${formattedHours}:${minutes}${ampm}`;
};

export const sortBillingPeriods = (billingPeriods) => {
  const textArr = [];
  const dateToPeriodMap = {};
  const dateRegex = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

  for (const item of billingPeriods) {
    const str = item.split('-')[0].trim(' ');
    const isValidDate = dateRegex.test(str);

    if (isValidDate) {
      dateToPeriodMap[str] = item;
    } else {
      textArr.push(item);
    }
  }
  const sortedDates = Object.keys(dateToPeriodMap).sort(
    (a, b) => new Date(b) - new Date(a)
  );

  const sortedBillingPeriods = sortedDates.map((date) => dateToPeriodMap[date]);

  return [...textArr.sort((a, b) => a - b), ...sortedBillingPeriods];
};

export const getLastDatesOfMonths = (inputDate) => {
  const [month, year] = inputDate.split('/').map(Number);
  const startDate = new Date(year, month - 1, 1);
  const currentDate = new Date();

  const lastDates = [];
  let currentMonth = startDate.getMonth();
  let currentYear = startDate.getFullYear();

  while (
    currentYear < currentDate.getFullYear() ||
    (currentYear === currentDate.getFullYear() &&
      currentMonth < currentDate.getMonth())
  ) {
    const lastDateOfMonth = new Date(currentYear, currentMonth + 1, 0);

    const day = String(lastDateOfMonth.getDate()).padStart(2, '0');
    const monthFormatted = String(lastDateOfMonth.getMonth() + 1).padStart(
      2,
      '0'
    );
    const yearFormatted = lastDateOfMonth.getFullYear();

    lastDates.push({
      label: `${day}-${monthFormatted}-${yearFormatted}`,
      value: `${yearFormatted}-${monthFormatted}-${day}`,
    });

    currentMonth++;
    if (currentMonth > 11) {
      currentMonth = 0;
      currentYear++;
    }
  }

  return lastDates;
};

export const postMessageTriggerPushSettingOnMobile = () => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        openNotificationSetting: true,
      })
    );
  }
};

export const fetchDeviceTokenForUser = async (oktaUserId) => {
  try {
    const response = await getAPICall(
      `deviceToken?oktaUserId=${oktaUserId}`,
      {
        isCallBack: true,
        errorTag: 'GET_DEVICE_TOKEN',
        logInfoMsg: 'fetch user device token',
        redirectToOops: false,
      },
      {}
    );
    return response?.Items || [];
  } catch (error) {
    console.error('Error fetching device token:', error);
    return [];
  }
};
